// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ignore":"ignore-1-7Qc","worst":"worst-2tDm0","worse":"worse-1gwEu","bad":"bad-3n0eW","invocab":"invocab-3nBgt","good":"good-1B1yV","ok":"ok-Pa4y8"};